module.exports = __webpack_public_path__ + "img/phase-1.f1b34c0d.svg";